<template>
  <div class="container">
    <div class="tile">
      <div class="tile-content">

        <form class="form-horizontal" v-on:submit="save">
          <div class="form-group">
            <div class="container">
              <div class="columns">
                <div class="col-3 col-md-12">
                  <label class="form-label">{{question.text}}</label>
                </div>
                <div class="col-4 col-md-12">
                  <div class="input-group">
                    <select class="form-select" v-model="answer.atxt" @blur="save" style="width:100%;">
                      <option value="">Choose an option</option>
                      <option v-for="opt in question.selectVals" :value="opt[1]">{{opt[0]}}</option>
                    </select>
                    <!-- <button type="submit" class="btn btn-primary input-group-btn" @click.prevent="save">Save</button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div class="tile-action">
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'selectQ',
  extends: baseQ
}
</script>



// WEBPACK FOOTER //
// select.vue?dcf34fb6